import { Type, type Static } from '@sinclair/typebox';
import { IsoDateTime } from './common';
import { StringEnum, createSchema } from '../../util/schema';

export const LastOpenedEntry = Type.Object({
  path: Type.String({ pattern: '^\\/' }),
  label: Type.String({ minLength: 1 }),
  openedAt: IsoDateTime,
});
export type LastOpenedEntry = Static<typeof LastOpenedEntry>;
export const lastOpenedEntrySchema = createSchema(LastOpenedEntry);

export const AnalyticsConsent = StringEnum(['granted', 'denied']);
export type AnalyticsConsent = Static<typeof AnalyticsConsent>;

export const UserSettings = Type.Object(
  {
    themeMode: StringEnum(['light', 'dark']),
    navCollapsed: Type.Boolean(),
    lastOpened: Type.Array(LastOpenedEntry),
    analyticsConsent: Type.Optional(AnalyticsConsent),
  },
  { $id: 'UserSettings' },
);
export type UserSettings = Static<typeof UserSettings>;
export const userSettingsSchema = createSchema(UserSettings);

export const defaultUserSettings = (): UserSettings => ({
  themeMode: 'light',
  navCollapsed: false,
  lastOpened: [],
});

/** Partial update — only provided fields are merged. */
export const UpdateUserSettings = Type.Partial(UserSettings, {
  $id: 'UpdateUserSettings',
  description: 'Partial merge — only provided fields are written.',
});
export type UpdateUserSettings = Static<typeof UpdateUserSettings>;
export const updateUserSettingsSchema = createSchema(UpdateUserSettings);

export const UpdateAccountInput = Type.Object(
  {
    firstName: Type.String({ minLength: 1 }),
    lastName: Type.String({ minLength: 1 }),
  },
  { $id: 'UpdateAccountInput' },
);
export type UpdateAccountInput = Static<typeof UpdateAccountInput>;
export const updateAccountInputSchema = createSchema(UpdateAccountInput);

export const AccountProfile = Type.Object(
  {
    email: Type.String({ format: 'email' }),
    firstName: Type.String(),
    lastName: Type.String(),
  },
  { $id: 'AccountProfile' },
);
export type AccountProfile = Static<typeof AccountProfile>;
export const accountProfileSchema = createSchema(AccountProfile);
